import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="max-w-7xl mx-auto p-6 mt-6 bg-white shadow-md border py-5 rounded-lg">
      <h1 className="text-3xl font-bold mb-1">Privacy Policy</h1>
      <p className="font-xs text-gray-600 pb-4 mb-4 border-b-2">
        Last updated 08 Aug 2024
      </p>
      <p className="mb-4">
        Welcome to Brain Box Study. Your privacy matters to us. This Privacy Policy explains how we collect, use, and protect your information when you visit our website.
      </p>

      <h2 className="text-xl font-semibold mb-2">1. Information We Collect</h2>
      <p className="mb-4">We may collect the following types of information:</p>
      <ul className="list-disc list-inside mb-4">
        <li>Personal Information – This includes your name, email, phone number, and other details you provide when you sign up or contact us.</li>
        <li>Usage Information – We may collect details like your IP address, browser type, device information, and the pages you visit to improve your experience.</li>
        <li>Payment Information – If you buy a course, your payment details are handled securely by trusted third-party providers.</li>
      </ul>

      <h2 className="text-xl font-semibold mb-2">2. How We Use Your Information</h2>
      <ul className="list-disc list-inside mb-4">
        <li>Provide and improve our courses and services.</li>
        <li>Send important updates, newsletters, and special offers.</li>
        <li>Improve website functions and user experience.</li>
        <li>Answer your questions and offer customer support.</li>
        <li>Follow legal rules and requirements.</li>
      </ul>

      <h2 className="text-xl font-semibold mb-2">3. Keeping Your Data Safe</h2>
      <p className="mb-4">
        We take strong measures to keep your data safe from unauthorized access, sharing, or misuse. However, no online system is 100% secure, so we recommend that you also take precautions when using the internet.
      </p>

      <h2 className="text-xl font-semibold mb-2">4. Cookies and Tracking</h2>
      <p className="mb-4">
        We use cookies to make your experience better, analyze website traffic, and personalize content. You can manage cookie settings in your browser.
      </p>

      <h2 className="text-xl font-semibold mb-2">5. Third-Party Services</h2>
      <p className="mb-4">
        We may use third-party services, such as payment providers and analytics tools, to handle data on our behalf. These services follow their own privacy policies.
      </p>

      <h2 className="text-xl font-semibold mb-2">6. Your Rights and Choices</h2>
      <ul className="list-disc list-inside mb-4">
        <li>View, update, or delete your personal details.</li>
        <li>Stop receiving marketing emails by clicking "unsubscribe" in any email.</li>
        <li>Turn off cookies using your browser settings.</li>
      </ul>

      <h2 className="text-xl font-semibold mb-2">7. Updates to This Policy</h2>
      <p className="mb-4">
        We may update this Privacy Policy from time to time. Any changes will be posted on this page, so we encourage you to check it regularly.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
